import React from "react";
import FieldSection from "../FieldSection";
import IntuitNumber from "./IntuitNumber";
import Logo from "./Logo";
import TemplateMetadataFields from "./TemplateMetadataFields";
import TemplateVisibility from "./TemplateVisiblity";
type Props = {};
export const TemplateAdminOptions: React.SFC<Props> = ({}) => {
  const [expanded, setExpanded] = React.useState(true);
  return (
    <FieldSection
      expanded={expanded}
      hasError={false}
      setExpanded={(isExpanded) => setExpanded(isExpanded)}
      heading="Admin Options"
    >
      <TemplateVisibility />
      <TemplateMetadataFields />
      <Logo />
      <IntuitNumber />
    </FieldSection>
  );
};
export default TemplateAdminOptions;
